import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

export const browserHistory = {
  ...createBrowserHistory(),
  createURL: (location: Parameters<typeof history.createHref>[0]) =>
    history.createHref(location),
  // For now, encodeLocation can be a passthrough. Adjust if app needs special encoding.
  encodeLocation: (location: any) => location,
};
